import React from "react";

function ErrorTemplate({
  children,
  className = "min-h-screen bg-gray-50 pt-8 pb-8",
  icon,
  title,
  description,
  actions = [],
}) {
  return (
    <div className={className}>
      <div className="max-w-2xl mx-auto text-center">
        {icon && <div className="mb-8">{icon}</div>}

        {title && (
          <h1 className="text-4xl font-bold text-gray-900 mb-6 leading-tight">
            {title}
          </h1>
        )}

        {description && (
          <p className="text-xl text-gray-600 mb-8">{description}</p>
        )}

        {actions.length > 0 && (
          <div className="space-x-4 mt-8">
            {actions}
          </div>
        )}

        {children}
      </div>
    </div>
  );
}

export default ErrorTemplate;
